import { call, put, takeLatest, all } from 'redux-saga/effects';

import api from 'core/utils/api';
import { actions } from '../store/test-form-reducer';

function* fetchDeviceSchema(action) {
  try {
    const res = yield call(api.get, `/forms/${action.payload}`);
    yield put(actions.fetchDeviceSchemaSuccess(res.data.form));
  } catch (err) {
    yield put(actions.fetchDeviceSchemaFail(err.response.data.error));
  }
}

function* watchFetchDeviceSchema() {
  yield takeLatest(actions.fetchDeviceSchema().type, fetchDeviceSchema);
}

export default function* testFormSaga() {
  yield all([
    watchFetchDeviceSchema(),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/test-form-saga.js